export default angular.module('gm.wealth.common')
  .directive('gmwMax', gmwMax)
  .name;

function gmwMax() {
  'ngInject';

  const directive = {
    link,
    restrict: 'A',
    require: 'ngModel',
  };
  return directive;

  function link(scope, _element, attrs, ctrl) {
    function checkValidity(origVal, origMax) {
      const max = parseFloat(origMax);
      let val = origVal;

      if (!isNaN(max)) {
        val = (isFinite(parseFloat(val))) ? parseFloat(val) : 0;
        ctrl.$setValidity('max', val <= max);
      } else {
        ctrl.$setValidity('max', true);
      }
    }

    attrs.$observe('gmwMax', (newMax) => {
      checkValidity(ctrl.$viewValue, newMax);
    });

    scope.$watch(() => ctrl.$viewValue, (newVal) => {
      checkValidity(newVal, attrs.gmwMax);
    });
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/common/directives/max/max.js